const CELLS = [
  { key: "strengths", title: "Strengths", sub: "Internal · Helpful", head: "bg-emerald-50 border-emerald-200 text-emerald-700" },
  { key: "weaknesses", title: "Weaknesses", sub: "Internal · Harmful", head: "bg-red-50 border-red-200 text-red-700" },
  { key: "opportunities", title: "Opportunities", sub: "External · Helpful", head: "bg-blue-50 border-blue-200 text-blue-700" },
  { key: "threats", title: "Threats", sub: "External · Harmful", head: "bg-amber-50 border-amber-200 text-amber-700" },
];

export default function SwotBlueprint({ doc }) {
  const p = doc.payload || {};
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="swot-blueprint">
      {CELLS.map((c) => (
        <div key={c.key} data-testid={`swot-${c.key}`} className="bg-white border border-slate-200 rounded-sm overflow-hidden">
          <div className={`px-4 py-3 border-b ${c.head}`}>
            <p className="font-mono text-sm font-bold uppercase tracking-wide">{c.title}</p>
            <p className="text-xs opacity-80">{c.sub}</p>
          </div>
          <div className="p-5 min-h-[140px]"><p className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">{p[c.key] || <span className="text-slate-300">—</span>}</p></div>
        </div>
      ))}
    </div>
  );
}
